import { getAgentById, listAgents } from './data'

const AGENT_ROUTE_PATTERN = /\/api\/agents\/?$/
const AGENT_DETAIL_PATTERN = /\/api\/agents\/([\w-]+)$/

const defaultOrigin = typeof location !== 'undefined' ? location.origin : 'http://localhost'

function resolveURL(input) {
  if (typeof input === 'string') {
    return new URL(input, defaultOrigin)
  }

  if (input instanceof URL) {
    return input
  }

  if (input && typeof input === 'object' && 'url' in input) {
    return new URL(input.url, defaultOrigin)
  }

  throw new Error('Unsupported request input for agent API mocking')
}

export function setupAgentApi() {
  if (globalThis.__agentApiMockApplied) {
    return
  }

  const originalFetch = globalThis.fetch.bind(globalThis)

  globalThis.fetch = async (input, init = {}) => {
    try {
      const url = resolveURL(input)

      const method = (init.method || (input && input.method) || 'GET').toUpperCase()

      if (method === 'GET' && AGENT_ROUTE_PATTERN.test(url.pathname)) {
        const agents = listAgents()
        return new Response(
          JSON.stringify({
            agents,
          }),
          {
            status: 200,
            headers: { 'Content-Type': 'application/json' },
          },
        )
      }

      if (method === 'GET') {
        const detailMatch = url.pathname.match(AGENT_DETAIL_PATTERN)
        if (detailMatch) {
          const [, agentId] = detailMatch
          const agent = getAgentById(agentId)
          if (!agent) {
            return new Response(JSON.stringify({ message: `Agent ${agentId} not found` }), {
              status: 404,
              headers: { 'Content-Type': 'application/json' },
            })
          }

          return new Response(JSON.stringify(agent), {
            status: 200,
            headers: { 'Content-Type': 'application/json' },
          })
        }
      }
    } catch (error) {
      console.warn('[agent-api] mock handler error:', error)
    }

    return originalFetch(input, init)
  }

  globalThis.__agentApiMockApplied = true
}
